export default __webpack_public_path__ + "static/media/books2-afterA-1440w.278d170a.png";